import axios from "axios";
import store from "@/store";
import notification from "ant-design-vue/es/notification";

// 创建 axios 实例
const service = axios.create({
  // baseURL: "/api-gateway", // api base_url
  timeout: 60000, // 请求超时时间 60s
  ignoreError: false, // 忽略200服务器返回失败，不提示
  // transformRequest: [function (data, headers) {
  //   if (headers['Content-Type']) {
  //     if (headers['Content-Type'] === 'multipart/form-data') {
  //       return data
  //     } else if (headers['Content-Type'].includes('application/json')) {
  //       return JSON.stringify(data)
  //     }
  //   }
  //   // 对 data 进行任意转换处理
  //   return Qs.stringify(data, { indices: false })
  // }],
  // transformResponse: [function (data) {
  //   let reponseVal = data
  //   const hasSecureJsonPrefix = data.startsWith('while')// 返回值添加了防JSON劫持代码
  //   if (data.startsWith('{') || data.startsWith('[') || hasSecureJsonPrefix) { // 返回值为json
  //     reponseVal = JSON.parse(hasSecureJsonPrefix ? data.substr(9) : data)
  //   }
  //   return reponseVal
  // }]
});
function errorLog(message) {
  notification.error({
    key: "Error",
    message: "内部错误",
    description: message || "服务器内部错误，请稍后重新尝试",
  });
  console.log("内部错误", message);
}

const err = (error) => {
  if (axios.isCancel(error)) {
    return new Promise(() => {});
  }

  if (error.response) {
    switch (error.response.status) {
      case 500:
        // errorLog();
        break;
      case 403:
        notification.error({
          key: "Forbidden",
          message: "无权限访问",
          description:
            ((error.response || {}).data || {}).message || "您无权访问该页面",
        });
        break;
      case 404:
        notification.error({
          key: "NotFound",
          message: "无法访问",
          description:
            ((error.response || {}).data || {}).message ||
            "网络异常或服务无法访问，请稍后重新尝试",
        });
        break;
      case 401:
        notification.error({
          key: "NotFound",
          message: "无法访问",
          description:
            ((error.response || {}).data || {}).message ||
            "网络异常或服务无法访问，请稍后重新尝试",
        });
        break;
      default:
        notification.error({
          key: "Unknown",
          message: "未知错误",
          description:
            ((error.response || {}).data || {}).message ||
            "未知错误，请稍后重新尝试",
        });
    }
  }
  return Promise.reject(error);
};

const CancelToken = axios.CancelToken;
service.interceptors.request.use(
  (config) => {
    // console.log('request -- ', config)
    // 根据接口的不同设置 baseURL
    // if (config.url.startsWith('/qfpt-api')) {
    //   config.baseURL = ''; // 第三方接口
    // } else {
    //   config.baseURL = '/api-gateway'; // 默认的 baseURL
    // }
    config.cancelToken = new CancelToken((cancel) => {
      store.state.requestCancels.push(cancel);
    });
    return config;
  },
  (error) => Promise.reject(error)
);

// response interceptor
service.interceptors.response.use((response) => {
  if (response.config.url.startsWith("/jpaas-jmap-web-server")) {
    const responseData = response.data;
    if (responseData) {
      responseData.headers = response.headers;
      const { success, message } = responseData;
      if (!success && !response.config.ignoreError) {
        errorLog(message);
        console.error(`接口 ${response.request.responseURL} 返回false`);
      }
      return response;
    }
  } else {
    return response;
  }
  // if (response.config.url.startsWith('/qfpt-api')) {
  //   const responseData = response.data
  //   if (responseData) {
  //     if (responseData.code === 500) {
  //       // errorLog(responseData.msg)
  //       console.error(`接口 ${response.request.responseURL} 返回false`)
  //     }
  //     return response
  //   }
  // }
}, err);

export default service;
